module.exports = __webpack_public_path__ + "static/img/shilelogo1.78342a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/shilelogo1.png
// module id = +1/m
// module chunks = 13